/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import axios from "axios";
import styles from "./css/login.module.css";
import { Field, Form, Formik } from "formik";
import { Button } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { AntInput, AntPassword } from "../hooks/createAntDFields";
import { loginInitialValue, loginValidation } from "../constants/login";
import { toast } from "react-toastify";
import loginURL from "../assets/loginAPI.js";
import appURL from "../assets/requesterURL.js";
import REACT_APP from "../environment.js";
import getCookie from "../assets/cookie/getCookie.jsx";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function SignInSide() {
    const [companyID, setCompanyID] = React.useState(localStorage.getItem("lc"));
    const validate = loginValidation();
    const [passwordVisible, setPasswordVisible] = React.useState(false);
    const [isWaiting, setIsWaiting] = React.useState(false);
    const [src, setSrc] = React.useState(null);

    const handleSubmit = (data) => {
        const url = localStorage.getItem("url");
        const reply = appURL(url);
        setIsWaiting(true);
        axios
            .post(`${loginURL(reply)}`, data)
            .then((res) => {
                setIsWaiting(false);
                window.onbeforeunload = {};
                localStorage.setItem("token", res.data?.data?.token);
                localStorage.setItem("lc", res.data?.data?.lc);
                localStorage.removeItem("url");
                window.location.replace(`${reply}?user=${res.data?.data?.token}`);
            })
            .catch((err) => {
                setIsWaiting(false);
                toast.error((err.response?.data?.errors && err.response?.data?.errors[0]?.message) || "Something went wrong");
            });
    };

    async function getLogo() {
        if (companyID)
            await fetch(`${REACT_APP.API_URL}/api/hrp/v2/employee/logo/${companyID}`, { method: "GET" })
                .then((res) => res.blob())
                .then((blob) => {
                    if (blob.type?.slice(0, 5) === "image") {
                        setSrc(window.URL.createObjectURL(blob));
                    }
                })
                .catch((err) => console.log(err));
    }

    useEffect(() => {
        getLogo();
    }, [companyID]);

    return (
        <div className={styles.container}>
            <Formik initialValues={loginInitialValue} validationSchema={validate} onSubmit={handleSubmit}>
                {({ submitCount }) => (
                    <Form autoComplete="off">
                        <div className={styles.loginBox}>
                            <div className={styles.h}>
                                <img src={src} alt="logo" className={src ? styles.logo : styles.logonull} />
                                <h1>{("Login")}</h1>
                            </div>
                            <Field
                                component={AntInput}
                                submitCount={submitCount}
                                size="large"
                                name="employee_id"
                                placeholder={("ID")}
                                autoComplete="username"
                                prefix={<UserOutlined color="red" />}
                                className={styles.input}
                            />
                            <Field
                                component={AntPassword}
                                submitCount={submitCount}
                                size="large"
                                name="password"
                                placeholder={("password")}
                                className={styles.input}
                                visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
                                prefix={<LockOutlined />}
                            />
                            <div className={styles.passwordLine}>{/* <Checkbox onChange={onChange}>remember me</Checkbox> */}</div>
                            <Button type="primary" className={styles.loginButton} size="large" htmlType="submit" disabled={isWaiting}>
                                {("Login")}
                            </Button>
                            <div className={styles.forgotPassword}>
                                <div>
                                    &#169;&nbsp;Transoxania&nbsp;{("LLC")}.&nbsp;{new Date().getFullYear()}
                                </div>
                                {/* <a href="#">forgot password</a> */}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

